module.exports = __webpack_public_path__ + "img/illu-icon-46-money-time.d6c375e7.svg";